module.exports = __webpack_public_path__ + "img/bg.50cce892.jpg";